import { Player } from '@lottiefiles/react-lottie-player'
import zeroToTen from '../assets/0-10.json'
import tenToNineteen from '../assets/10-19.json'
import twentyToTwentyNine from '../assets/20-29.json'
import thirtyToThirtyNine from '../assets/30-39.json'
import fourtyToFourtyNine from '../assets/40-49.json'
import fiftyToFityNine from '../assets/50-59.json'
import sixtyToSixtyNine from '../assets/60-69.json'
import seventyToSeventyNine from '../assets/70-79.json'
import eightyToEightyNine from '../assets/80-89.json'
import ninetyToTwoHundred from '../assets/90-200.json'

function returnCurrentIcon(level: string) {
  const comparer = Number(level)

  if (comparer >= 0 && comparer <= 10) {
    return zeroToTen
  }

  if (comparer > 10 && comparer <= 19) {
    return tenToNineteen
  }

  if (comparer > 19 && comparer <= 29) {
    return twentyToTwentyNine
  }

  if (comparer > 29 && comparer <= 39) {
    return thirtyToThirtyNine
  }

  if (comparer > 39 && comparer <= 49) {
    return fourtyToFourtyNine
  }

  if (comparer > 49 && comparer <= 59) {
    return fiftyToFityNine
  }

  if (comparer > 59 && comparer <= 69) {
    return sixtyToSixtyNine
  }

  if (comparer > 69 && comparer <= 79) {
    return seventyToSeventyNine
  }

  if (comparer > 79 && comparer <= 89) {
    return eightyToEightyNine
  }

  if (comparer > 89) {
    return ninetyToTwoHundred
  }

  return ninetyToTwoHundred
}

export function BadgeLevel({ level }: { level: string | number }) {
  if (!level) {
    return null
  }

  const currentIcon = returnCurrentIcon(level as string)

  return (
    <div className="relative inline-flex h-4 w-9 shrink-0 items-center align-middle" style={{ transform: 'translateY(-1px)' }}>
      <Player loop autoplay src={currentIcon} className="h-4 w-9" />

      <span className="absolute inset-y-0 right-1.5 inline-flex items-center text-[7px] font-bold leading-none text-white">
        <span style={{ position: 'relative', top: '1px' }}>{level}</span>
      </span>
    </div>
  )
}
